<template>
  <v-row>      
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Customers'"></Breadcrumbs>
      <CustomerGrid></CustomerGrid>
    </div>
    <div class="col-md-12 home-tabs-body">
    </div>
  </v-row>
</template>

<script>

import CustomerGrid from "@/components/customers/CustomerGrid";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Customers",
  components: {
    CustomerGrid,
    Breadcrumbs
  },
  data: function () {
    return {
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile"
    })
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
  },

  watch: {

  },

  methods: {

  },

};
</script>
